import { defineStore } from 'pinia'

const LiqpayStates = {
    liqpayRequest: null,
    action       : 'pay',
    subscription : null,
    referral     : null,
    value: 0
}

export const useLiqpayStore = defineStore({
    id: 'liqpay',

    // initial state
    state () {
        return {
            cart:         Object.assign({}, LiqpayStates, {action: 'pay'}),
            subscription: Object.assign({}, LiqpayStates, {action: 'subscribe'}),

            loaded: false,      // Liqpay script is loaded
            ready : false,      // Liqpay script is ready to run
            error : false       // Error occured on liqpay loading
        }
    },

    actions: {
        liqpayLoaded () {
            this.loaded = true;
        },

        liqpayReady () {
            this.ready = true;
        },

        liqpayError () {
            this.error = true;
        },

        setLiqpayRequest ({request, liqpay}) {
            this[liqpay].liqpayRequest = request;
        },

        setSubscription ({ liqpay, slug, price, referral = null }) {
            this[liqpay].subscription = slug;
            this[liqpay].value        = price;
            this[liqpay].referral     = referral;
        },
    }
})
